import * as React from "react";

export const Banner: React.FunctionComponent = () => {
  return (
    <div className="forgot-password-banner">
      <div className="hero-background"/>
      <h1>{`Reset Your Password`}</h1>
    </div>
  );
};
